import { useState, useEffect } from 'react';
import api from '../services/api';

export default function ClienteContatos({ clienteId }) {
  const [contatos, setContatos] = useState([]);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState({ nome: '', cargo: '', telefone: '', email: '', principal: false });

  useEffect(() => { carregar(); }, [clienteId]);

  async function carregar() {
    const res = await api.get(`/contatos/cliente-contatos/${clienteId}`);
    setContatos(res.data);
  }

  async function salvar() {
    if (!form.nome.trim()) { alert('Nome é obrigatório!'); return; }
    if (editando) {
      await api.put(`/contatos/cliente-contatos/${editando}`, { ...form, cliente_id: clienteId });
    } else {
      await api.post('/contatos/cliente-contatos/', { ...form, cliente_id: clienteId });
    }
    setForm({ nome: '', cargo: '', telefone: '', email: '', principal: false });
    setEditando(null);
    setMostrarForm(false);
    carregar();
  }

  async function desativar(id) {
    if (window.confirm('Remover este contato?')) {
      await api.delete(`/contatos/cliente-contatos/${id}`);
      carregar();
    }
  }

  function editar(c) {
    setForm({ nome: c.nome, cargo: c.cargo || '', telefone: c.telefone || '', email: c.email || '', principal: c.principal || false });
    setEditando(c.id);
    setMostrarForm(true);
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <span style={styles.titulo}>👥 Contatos</span>
        <button style={styles.botaoAdd} onClick={() => { setMostrarForm(!mostrarForm); setEditando(null); setForm({ nome: '', cargo: '', telefone: '', email: '', principal: false }); }}>
          + Adicionar
        </button>
      </div>

      {mostrarForm && (
        <div style={styles.form}>
          <div style={styles.grid}>
            <div style={styles.campo}>
              <label style={styles.label}>Nome *</label>
              <input style={styles.input} value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} />
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Cargo</label>
              <input style={styles.input} value={form.cargo} onChange={e => setForm({ ...form, cargo: e.target.value })} />
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Telefone/WhatsApp</label>
              <input style={styles.input} value={form.telefone} onChange={e => setForm({ ...form, telefone: e.target.value })} placeholder="Ex: 11999999999" />
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Email</label>
              <input style={styles.input} value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '8px 0' }}>
            <input type="checkbox" checked={form.principal} onChange={e => setForm({ ...form, principal: e.target.checked })} id="principal" />
            <label htmlFor="principal" style={{ fontSize: '12px', color: '#555', cursor: 'pointer' }}>Contato principal</label>
          </div>
          <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
            <button style={styles.botaoSalvar} onClick={salvar}>Salvar</button>
            <button style={styles.botaoCancelar} onClick={() => { setMostrarForm(false); setEditando(null); }}>Cancelar</button>
          </div>
        </div>
      )}

      {contatos.length === 0 ? (
        <p style={styles.vazio}>Nenhum contato cadastrado</p>
      ) : (
        <div style={styles.lista}>
          {contatos.map(c => (
            <div key={c.id} style={styles.item}>
              <div style={styles.info}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <span style={styles.nome}>{c.nome}</span>
                  {c.principal && <span style={styles.badge}>Principal</span>}
                </div>
                <span style={styles.meta}>
                  {c.cargo && `${c.cargo} · `}
                  {c.telefone && `📱 ${c.telefone} `}
                  {c.email && `✉️ ${c.email}`}
                </span>
              </div>
              <div style={{ display: 'flex', gap: '6px' }}>
                <button style={styles.botaoEditar} onClick={() => editar(c)}>Editar</button>
                <button style={styles.botaoRemover} onClick={() => desativar(c.id)}>✕</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const styles = {
  container: { marginTop: '1rem', backgroundColor: '#f9f9f9', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '1rem' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' },
  titulo: { fontSize: '13px', fontWeight: '600', color: '#1a1a2e' },
  botaoAdd: { backgroundColor: '#1a1a2e', color: '#fff', border: 'none', padding: '5px 12px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' },
  form: { backgroundColor: '#fff', border: '1px solid #e0e0e0', borderRadius: '6px', padding: '12px', marginBottom: '12px' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' },
  campo: { display: 'flex', flexDirection: 'column' },
  label: { fontSize: '11px', color: '#555', marginBottom: '3px' },
  input: { padding: '7px 10px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '13px' },
  botaoSalvar: { backgroundColor: '#1a1a2e', color: '#fff', border: 'none', padding: '7px 16px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' },
  botaoCancelar: { backgroundColor: 'transparent', color: '#888', border: '1px solid #ddd', padding: '7px 16px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' },
  vazio: { fontSize: '12px', color: '#aaa', textAlign: 'center', padding: '1rem 0' },
  lista: { display: 'flex', flexDirection: 'column', gap: '6px' },
  item: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#fff', border: '1px solid #eee', borderRadius: '6px', padding: '8px 12px' },
  info: { display: 'flex', flexDirection: 'column', gap: '2px' },
  nome: { fontSize: '13px', fontWeight: '500', color: '#1a1a2e' },
  badge: { backgroundColor: '#e8f5e9', color: '#388e3c', fontSize: '10px', padding: '2px 6px', borderRadius: '10px', fontWeight: '500' },
  meta: { fontSize: '11px', color: '#888' },
  botaoEditar: { backgroundColor: 'transparent', color: '#1a1a2e', border: '1px solid #ddd', padding: '3px 10px', borderRadius: '4px', fontSize: '11px', cursor: 'pointer' },
  botaoRemover: { backgroundColor: 'transparent', color: '#e53935', border: '1px solid #e53935', padding: '3px 8px', borderRadius: '4px', fontSize: '11px', cursor: 'pointer' },
};